import React, {Component} from 'react'
import classNames from "classnames"
import {Icon, Modal, Popconfirm, Button, Checkbox, Collapse, Upload, message} from 'antd'
import PropTypes from "prop-types"
import {Link} from "react-router-dom"
import OrderMockUp from "./data/OrderMockUp"
import ListItemsQCnotMask from "./ListItemsQCnotMask"
import MarkItemError from "./MarkItemError"
import SewingRepairModal from './SewingRepairModal'
import {listPartner, getListSku, markSewingRepair, markErrorEmbroidered, markSewingThreadColor} from "../../../../services/api/3dApi"
import {ERROR_SEWING, ERROR_EMBROIDERED, SEWING_THREAD_COLOR_REASONS, SEWING_THREAD_COLOR_LABEL} from "../../contant/ListOption.json"
import { EyeTwoTone } from '@ant-design/icons'
import ThreadColorImage from '../../../batch/components/data/ThreadColorImage'
import { isAbsoluteUrl } from '../../../batch/components/data/ThreadColorImage'
import ToggleSafeZone from '../../../home/components/orders/actions/ToggleSafeZone'

const DEFAULT_ALLOWED_THREAD_COLORS = ['WHITE', 'BLACK', 'GREY']

class ItemQCnotMask extends Component {
    constructor(props) {
        super(props)

        const sewingThreadColor = this._findSewingThreadColor(props)

        this.state = {
            visible: false,
            width: 0,
            height: 0,
            isOpen: false,
            showSewingRepair: false,
            isPartnerGlobal: false,
            partnerQM: {},
            isPartnerQM: false,
            previewOpen: false,
            previewColorImage: '',
            isModalMarkErrorEmbroidered: false,
            offSafeZone: false,
            threadColorChecked: sewingThreadColor ? sewingThreadColor.used : null,
            showThreadColorReason: false,
            threadColorReasonSelected: '',
            threadColorLoading: false,
            sewingThreadColorOverride: null,
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    }

    _findSewingThreadColor = (props) => {
        const { sewingThreadColor, item } = props

        if (!Array.isArray(sewingThreadColor) || !sewingThreadColor.length) return null

        let is3d = item
        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }
        const { barcode_number, item_number } = is3d

        return sewingThreadColor.find(i => (
            String(i.barcode) === String(barcode_number) && String(i.item_index) === String(item_number)
        )) || null
    }

    _getSewingThreadColor = () => {
        const sewingThreadColor = this._findSewingThreadColor(this.props)
        const { sewingThreadColorOverride } = this.state

        if (!sewingThreadColorOverride) return sewingThreadColor

        return { ...sewingThreadColor, ...sewingThreadColorOverride }
    }

    componentDidMount() {
        (async () => {
            this.updateWindowDimensions()
            await this._fetchPartners()
            // this._fetchSku()
        })()
        window.addEventListener('resize', this.updateWindowDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions)
    }

    updateWindowDimensions() {
        this.setState({width: window.innerWidth, height: window.innerHeight})
    }

    _showModal = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            visible: false,
        })
    }

    _toggleSafeZone = () => {
        this.setState({
            offSafeZone: !this.state.offSafeZone
        })
    }

    _fetchPartners = async () => {
        const {item} = {...this.props}
        let is3d = item
        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }
        const partnerCheck = !!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch && is3d.batch_item.batch.partner

        try {
            const {data: response} = await listPartner()

            const {success, error, data} = response

            if (!success) {
                this.setState({
                    error
                })

                return
            }
            const partnerItem = data.partners.find(partner => partner._id === partnerCheck)
            const partnerQM = data.partners.find(partner => partner.name === 'QUANG MINH' && partner.code === 'HN89')
            this.setState({
                error: '',
                isPartnerGlobal: partnerItem.code === "AJL4" ? true : false,
                partnerQM: partnerQM,
            })
        } catch (e) {
            this.setState({})
        }
    }

    _fetchSku = async () => {
        const {item} = {...this.props}
        const {partnerQM} = this.state

        try {
            const payload = {
                limit: 10000,
                partner: [partnerQM._id]
            }
            const {data: res} = await getListSku(payload)
            const {data, success, message} = {...res}
            if (!success) {
                console.log(message)
                return
            }
            const listSku = data.items.map(i => i.sku)
            this.setState({
                isPartnerQM: !!listSku && listSku.includes(item.type) ? true : false
            })
        } catch (error) {
            console.log(error)
        }
    }

    _handleChangeChecked = () => {
        const {item, updateOrdersSelected} = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const {tool3d_order} = item

            if (!item.can_qc_completed) return

            const {_id: orderID} = tool3d_order

            const isChecked = this._detectChecked()

            updateOrdersSelected(orderID, !isChecked)
        }
    }

    _detectChecked = () => {
        const {item, arrChecked} = this.props

        if (item.hasOwnProperty('tool3d_order')) {
            const {tool3d_order} = item
            const {_id: orderID} = tool3d_order

            return arrChecked.includes(orderID)
        }
    }

    _isOpenModal = () => {
        document.body.classList.add('CustomSelect')

        this.setState({
            isOpen: true
        })
    }

    _isOpenSewingRepairModal = () => {
        document.body.classList.add('CustomSelect')

        this.setState({
            showSewingRepair: true
        })
    }

    _isOpenMarkErrorEmbroidered = () => {
        document.body.classList.add('CustomSelect')

        this.setState({
            isModalMarkErrorEmbroidered: true
        })
    }

    _isCloseMarkErrorEmbroidered = () => {
        document.body.classList.remove('CustomSelect')

        this.setState({
            isModalMarkErrorEmbroidered: false
        })
    }

    _isCloseModal = () => {
        document.body.classList.remove('CustomSelect')

        this.setState({
            isOpen: false
        })
    }

    _isCloseSewingRepairModal = () => {
        document.body.classList.remove('CustomSelect')

        this.setState({
            showSewingRepair: false
        })
    }

    _handlePreview = (file) => {
        this.setState({
            previewOpen: true,
            previewColorImage: file.url
        })
    }

    _handleChangeThreadColor = (value) => {
        const sewingThreadColor = this._getSewingThreadColor()
        const { used } = sewingThreadColor || {}
        this.setState({
            threadColorChecked: value,
            showThreadColorReason: value !== used,
        })
    }

    _resetThreadColorSelection = () => {
        const sewingThreadColor = this._getSewingThreadColor()
        const { used } = sewingThreadColor || {}
        this.setState({
            threadColorChecked: used,
            showThreadColorReason: false,
        })
    }

    _handleSelectReason = async (reason) => {
        const { threadColorChecked } = this.state
        let is3d = this.props.item
        if (this.props.item.hasOwnProperty('tool3d_order')) {
            is3d = this.props.item.tool3d_order
        }
        const { barcode_number, item_number } = is3d

        const sewingThreadColor = this._getSewingThreadColor()
        const { current } = sewingThreadColor || {}
        const usedReason = threadColorChecked !== current ? 'SEWING_CORRECTION' : 'MAPPING_UPDATED'

        this.setState({ threadColorLoading: true, threadColorReasonSelected: reason })
        try {
            const payload = {
                barcode: `${barcode_number}_${item_number}`,
                thread_color_used: threadColorChecked,
                used_reason: usedReason,
                reason_text: reason,
            }
            const { data: res } = await markSewingThreadColor(payload)
            const { success, error } = res || {}
            if (!success) throw new Error(error)

            message.success('Cập nhật màu chỉ may thành công')
            this.setState({
                threadColorLoading: false,
                showThreadColorReason: false,
                threadColorReasonSelected: '',
                sewingThreadColorOverride: {
                    used: threadColorChecked,
                    used_reason: usedReason,
                    reason_text: reason,
                },
            })
        } catch (e) {
            message.error(e.message)
            this.setState({ threadColorLoading: false, threadColorReasonSelected: '' })
        }
    }

    render() {
        const {visible, height, isOpen, showSewingRepair, isPartnerGlobal, partnerQM, previewOpen, previewColorImage, isModalMarkErrorEmbroidered, offSafeZone, threadColorChecked, showThreadColorReason, threadColorReasonSelected, threadColorLoading} = this.state
        const {
            item,
            defaultChecked,
            outItems,
            cancelQC,
            typeQC,
            allSelected,
            toggleSelectAll,
            loading,
            loadingQC1ST,
            selectedItem,
            textLoading,
            name,
            submitQC,
            submitQC1ST,
            inputValue,
            totalItems,
            allItems,
            reset,
            relatedSkuWithInputBarcode,
            storename,
            itemSets,
            onChangeItemSet,
            designRootMismatchWarning,
        } = this.props

        const isChecked = this._detectChecked()
        const isDefaultChecked = (defaultChecked !== undefined && defaultChecked.length > 0) ? defaultChecked.includes(item._id) : false
        let is3d = item

        if (item.hasOwnProperty('tool3d_order')) {
            is3d = item.tool3d_order
        }

        const sewingThreadColor = this._getSewingThreadColor()

        const showSafeZone = (category, dimension) => {
            if (!!is3d.safezone_image) {
                return <img style={{height: `${height - 210}px`}} src={is3d.safezone_image} alt="SafeZone"
                    className="Safezone"/>
            }
        }

        const showSafeZone2 = (category, dimension) => {
            if (!!is3d.safezone_image) {
                return <img src={is3d.safezone_image} alt="SafeZone"
                    className="Safezone"/>
            }
        }

        const transformDataToFileList = (data) => {
            return Array.isArray(data)
                ? data.map(cf => ({
                    uid: cf.file_name,
                    name: cf.file_name,
                    status: 'done',
                    url: cf.url,
                }))
                : []
        }

        const {mock_up_front, mock_up_back, type, size, batch_item, tags, embroidery_area_info = {}, meta = {}, production_status, thread_color_note = ''} = is3d
        const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
        const isCutoffTag = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const hasSpecialTag = !!isFastProductionTag || (!!isCutoffTag || !!isCutOffNoel || !!isCutOffNewYear)
        const {mark_as_qc_1st, batch, product_type} = {...batch_item}
        const {brand_name = '', brand_tags = {}} = item
        const {branding} = {...brand_tags}
        const { description, partner: itemPartner, brands_description_packaged: brandsDescriptionPackaged = [] } = { ...relatedSkuWithInputBarcode }
        const { id: partner } = { ...itemPartner }
        const isPartnerQM = !!partnerQM && !!partnerQM._id && partnerQM._id === partner
        const listDes = !!description && description.split('\n')
        const skuNotQC1ST = [
            'MASKCC_3D', 'MASKCCNUT_3D', 'MASK_3D', 'MASK_HYPER_3D', 'MASK_SQUARE_3D', 'MASK_PS_3D', 'MASK_PQ_3D', 'MASKCC_V2_3D', 'MASK_NEP_3D',
            'MASK_NEP_NUT_3D', 'MASK_NUT_3D', 'FILTER', 'STICKER', 'BRAND_KIT', 'UV_LED', 'UV_LED_MICA', 'ENGRAVED_LED',
            'UV_HEART_HOLDER', 'UV_HOLDER', 'ORNAMENT_3D', 'CUT_ORNAMENT_3D', 'ENGRAVED_ORNAMENT_3D', '1_MDF_ORNAMENT_3D', '2_MDF_ORNAMENT_3D',
            'MDF_CUSTOM_ORNAMENT_3D', 'CUSTOM_ORNAMENT_3D', 'CUSTOM_ORNAMENT_V2_3D', 'CUSTOM_CAR_ORNAMENT', 'PLASTIC_CAR_ORNAMENT', '1_PLASTIC_CAR_ORNAMENT',
            'PLASTIC_WINDOW_ORNAMENT', '1L_WOOD_ORNAMENT', '2L_WOOD_ORNAMENT', 'WOOD_ACRYLIC_ORNAMENT', '1_WHITE_PLASTIC_ORNAMENT', '1_WHITE_PLASTIC_CAR_ORNAMENT',
            '1L_WOOD_ORNAMENT_UID', 'MICA_ORNAMENT_UID', 'WOOD_KEYCHAIN_3D', 'MICA_KEYCHAIN_V2_3D', 'MICA_KEYCHAIN_3D', 'PET_KEYCHAIN_3D', 'MICA_PIN',
            'MASKCC_01', 'MASK_01', 'MASK_SQUARE_01', 'MASKCC_V2_01', 'STICKER', 'BRAND_KIT', 'CUT_ORN_0203CU', '1L_KEY_0103MT', '2L_KEY_0102MT', '1W_ORN_0103MT',
            '1L_ORN_0203TM', '2L_ORN_0203TM', 'CUSTOM_ORN_0103MTM', 'HEART_HOLDER_0250TM', 'HOLDER_0250TM', 'UV_LED_0103MT', '2L_REG_ORN_12MT', 
        ]
        const disabledBtnQC = loading || selectedItem.length === 0 ||
            (isPartnerQM && !!is3d.tags && is3d.tags.includes('priority-store') && !mark_as_qc_1st && !skuNotQC1ST.includes(product_type)) ||
            (!!itemSets.length && itemSets.some(i => !i.checked))
        const disabledBtnQC1ST = loadingQC1ST || selectedItem.length === 0 ||
            (isPartnerQM && !!is3d.tags && is3d.tags.includes('priority-store') && !!mark_as_qc_1st && !skuNotQC1ST.includes(product_type)) ||
            (!!itemSets.length && itemSets.some(i => !i.checked))

        const isMadeInVN = Array.isArray(tags) && tags.includes('made_vn')

        const { embroidery_sides = [] } = meta || {}
        const { embroidery_positions = [], embroidery_colors = {}, color_files = {} } = embroidery_area_info || {}
        const listColor = embroidery_colors
        const embroiderySides = Array.isArray(embroidery_sides) && !!embroidery_sides.length ? embroidery_sides : (Array.isArray(embroidery_positions) && !!embroidery_positions.length ? embroidery_positions : [])
        const firstSideIndex = embroiderySides.findIndex(side => {
            const colors = listColor[side]
            const colorFiles = color_files[side]
            const hasColor = (Array.isArray(colors) && colors.length > 0) || (Array.isArray(colorFiles) && colorFiles.length >0)
            return hasColor
        })
        const brandDescription = brandsDescriptionPackaged.find(i => i.brand === brand_name) || {}

        return (
            <div className="wrapItem ItemQCnotMask">
                <div
                    className={classNames((isChecked || isDefaultChecked) ? 'position-relative itemChecked' : 'position-relative')}>
                    <div className="infoContent col-5 px-0 d-flex justify-content-between flex-wrap w-100">
                        <div className="leftContent">
                            <div className="d-flex BasicInfo infoItemNotMask flex-wrap align-items-center ">
                                <div className="Type mr-2"><strong>{item.type}</strong></div>
                                {
                                    !!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch &&
                                    <div className="badge badge-success badge-pill mr-2 Batch"><Link
                                        to={`/batches/${is3d.batch_item.batch._id}`}>{is3d.batch_item.batch.name}</Link>
                                    </div>
                                }
                                <div className="badge badge-success badge-pill mr-2">
                                    {!!is3d.hasOwnProperty('batch_item') && !!is3d.batch_item.batch && is3d.batch_item.status}
                                </div>
                                <div className="badge badge-secondary badge-pill mr-2">{is3d.size}</div>
                                <div className="badge badge-secondary badge-pill mr-2">{is3d.item_number}</div>
                                {
                                    !!brand_name && <div className="Brand mr-2 badge badge-danger badge-pill py-1 px-2">
                                        {brand_name}
                                    </div>
                                }
                                {
                                    !!branding && <div className="Brand mr-2 border border-danger text-danger py-1 px-2 my-1">
                                        {
                                            branding.map((item, index) => (
                                                index ? `, ${item.name}` : item.name
                                            ))
                                        }
                                    </div>
                                }
                            </div>
                            {
                                totalItems > 0 && (
                                    <div className="total mb-3">
                                        <strong>{typeQC ? (allItems.length) : 1}</strong> đơn
                                        cần đánh dấu
                                    </div>
                                )
                            }
                        </div>
                        <div className="rightContent">
                            {isMadeInVN &&
                                <span className='mb-2 tagVN'>Made in VN</span>
                            }
                        </div>
                    </div>
                    {!!sewingThreadColor &&
                        <div className='sewing-thread-color-box col-5 border rounded p-3 mb-3'>
                            <div className='d-flex align-items-center flex-wrap'>
                                <span className='font-weight-bold mr-2'>Chỉ may:</span>
                                {['WHITE', 'BLACK', 'GREY', 'RED'].map(color => {
                                    const { used, allowed_colors: allowedColors } = sewingThreadColor
                                    const isNewlySelected = showThreadColorReason && threadColorChecked === color && color !== used
                                    const isChecked = color === used
                                    const effectiveAllowedColors = Array.isArray(allowedColors) ? allowedColors : DEFAULT_ALLOWED_THREAD_COLORS
                                    const isDisabled = !effectiveAllowedColors.includes(color)
                                    return (
                                        <span
                                            key={color}
                                            className={classNames('sewing-thread-color-option d-inline-flex align-items-center mr-2', {
                                                'is-checked': isChecked,
                                                'is-newly-selected': isNewlySelected,
                                                'is-disabled': isDisabled,
                                            })}
                                            style={isDisabled ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
                                            onClick={() => !isDisabled && this._handleChangeThreadColor(color)}
                                        >
                                            <span
                                                className='mr-1 d-inline-block'
                                                style={{
                                                    width: 12,
                                                    height: 12,
                                                    borderRadius: 3,
                                                    border: '1px solid #adb5bd',
                                                    background: color === 'WHITE' ? '#fff' : color === 'BLACK' ? '#000' : color === 'RED' ? '#e02020' : '#adb5bd',
                                                }}
                                            />
                                            {SEWING_THREAD_COLOR_LABEL[color].toUpperCase()}
                                            {(isChecked || isNewlySelected) && <span className='ml-1'>✓</span>}
                                        </span>
                                    )
                                })}
                            </div>
                            <div
                                className='d-inline-block mt-2 px-3 py-1'
                                style={{ background: '#fdf0e0', color: '#c47a1c', borderRadius: 8, fontSize: 14 }}
                            >
                                {(() => {
                                    const { printed, used, used_reason: usedReason } = sewingThreadColor
                                    const UNDETERMINED = 'CHƯA XÁC ĐỊNH'
                                    const printedLabel = SEWING_THREAD_COLOR_LABEL[printed] || UNDETERMINED
                                    const currentLabel = SEWING_THREAD_COLOR_LABEL[used] || UNDETERMINED
                                    if (usedReason === 'SEWING_CORRECTION') {
                                        return `QR in: ${printedLabel} · Đã may: ${currentLabel} · Nguồn: thợ may đổi (SEWING_CORRECTION) — không phải lỗi`
                                    }
                                    if (usedReason === 'MAPPING_UPDATED') {
                                        return `QR in: ${printedLabel} · Đã may: ${currentLabel} · Nguồn: mapping đã cập nhật — không phải lỗi`
                                    }
                                    const source = usedReason ? usedReason : (printed && used ? 'đúng như đã in' : UNDETERMINED)
                                    return `QR in: ${printedLabel} · Đã may: ${currentLabel} · Nguồn: ${source}`
                                })()}
                            </div>
                            {showThreadColorReason &&
                                <div className='thread-color-reason mt-3 p-3' style={{ background: '#eaf3fb', borderRadius: 8 }}>
                                    <div className='font-weight-bold' style={{ color: '#2b6cb0' }}>
                                        Đổi màu chỉ {SEWING_THREAD_COLOR_LABEL[sewingThreadColor.used]} → {SEWING_THREAD_COLOR_LABEL[threadColorChecked]}?
                                    </div>
                                    <div className='mt-1' style={{ color: '#2b6cb0' }}>
                                        Chỉ ghi nhận để Detect Tool học cho các item cùng thiết kế về sau.
                                        <strong>Không</strong> đánh dấu lỗi, <strong>không</strong> tái tạo item, <strong>không</strong> khoá thao tác nào bên dưới. Chọn lý do:
                                    </div>
                                    <div className='d-flex flex-wrap mt-2'>
                                        {SEWING_THREAD_COLOR_REASONS.map(reason => (
                                            <Button
                                                key={reason}
                                                shape='round'
                                                className='mr-2 mb-2'
                                                loading={threadColorLoading && threadColorReasonSelected === reason}
                                                disabled={threadColorLoading}
                                                onClick={() => this._handleSelectReason(reason)}
                                            >{reason}</Button>
                                        ))}
                                    </div>
                                    <Button
                                        shape='round'
                                        disabled={threadColorLoading}
                                        onClick={this._resetThreadColorSelection}
                                    >Hủy</Button>
                                    <div className='mt-2 text-muted' style={{ fontSize: 13 }}>
                                        Chạm một lý do = xác nhận. Đánh dấu QC / Đánh dấu lỗi / Sửa may vẫn dùng được bình thường.
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="row">
                        <div className="col-sm-5">
                            {storename === "zlk0ggs" && <span className='store-name'>Store: {storename}</span>}
                            {!embroiderySides.length &&
                                <OrderMockUp mockUpFront={mock_up_front} mockUpBack={mock_up_back} orderId={item._id} />
                            }
                            {embroiderySides.length > 0 &&
                                <div className='mb-4 side'>
                                    <div className='d-flex align-items-center'>
                                        <h4 className='font-weight-bold' style={{whiteSpace:'nowrap'}}>MẶT THÊU</h4>
                                        {
                                            !!thread_color_note &&
                                            <h4 className='text-danger font-weight-bold ml-3' style={{ color: '#ee2b4f', fontSize: 16, wordBreak: 'break-word' }}>
                                                Màu chỉ yêu cầu: {!!isAbsoluteUrl(thread_color_note) ?
                                                    <ThreadColorImage ImageUrl={thread_color_note} /> :
                                                    thread_color_note
                                                }
                                            </h4>
                                        }
                                    </div>
                                    <Collapse
                                        bordered
                                        defaultActiveKey={[firstSideIndex]}
                                        expandIconPosition={'right'}
                                    >
                                        {embroiderySides.length > 0 && embroiderySides.map((i, idx) => (
                                            <Collapse.Panel
                                                header={<h5 className='w-100 mb-0 text-uppercase' style={{ fontWeight: 700, color: '#fff' }}>{i}</h5>}
                                                key={idx}
                                                className='w-100'
                                            >
                                                {((!!Array.isArray(listColor[i]) && listColor[i].length > 0) || color_files[i]) &&
                                                    <div className='mb-4 embroideryColors'>
                                                        <div className="d-flex flex-wrap justify-content-between">
                                                            <h5 className=''>CÁC BƯỚC MÀU THÊU:</h5>
                                                            {!!color_files[i] &&
                                                                <div
                                                                    className="UploadImage w-100"
                                                                >
                                                                    <Upload
                                                                        className={`UploadImages ${i}`}
                                                                        listType="picture-card"
                                                                        onPreview={this._handlePreview}
                                                                        fileList={transformDataToFileList(color_files[i] || [])}
                                                                        accept="image/*"
                                                                        onDownload={true}
                                                                        disabled={true}
                                                                        showUploadList={
                                                                            {
                                                                                showDownloadIcon: true,
                                                                                downloadIcon: 'Download',
                                                                                showRemoveIcon: false,
                                                                                showPreviewIcon: true,
                                                                            }
                                                                        }
                                                                        style={{ width: 200, height: 200 }}
                                                                    >
                                                                    </Upload>
                                                                </div>
                                                            }
                                                        </div>
                                                        {!!Array.isArray(listColor[i]) && listColor[i].length > 0 &&
                                                            <div className="listColor d-flex flex-wrap justify-content-start">
                                                                <div className="list1 d-flex flex-column mr-5">
                                                                    {listColor[i].map((color, colorIdx) => (
                                                                        colorIdx < (listColor[i].length % 2 === 0 ? listColor[i].length / 2 : Math.ceil(listColor[i].length / 2)) &&
                                                                        <span key={`color_${colorIdx}`} style={{ fontSize: 20, fontWeight: 600 }}>{`${colorIdx + 1}. ${color}`}</span>
                                                                    ))}
                                                                </div>
                                                                <div className="list2 d-flex flex-column">
                                                                    {listColor[i].map((color, colorIdx) => (
                                                                        colorIdx >= (listColor[i].length % 2 === 0 ? listColor[i].length / 2 : Math.ceil(listColor[i].length / 2)) &&
                                                                        <span key={`color_${colorIdx}`} style={{ fontSize: 20, fontWeight: 600 }}>{`${colorIdx + 1}. ${color}`}</span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </Collapse.Panel>
                                        ))}
                                    </Collapse>
                                </div>
                            }

                            <div className="foot d-flex align-items-center justify-content-between w-100">
                                <div className='col-5 px-0'>
                                    <button type="button" onClick={cancelQC} className="btn btn-outline-secondary">
                                        Hủy
                                    </button>
                                    {
                                        !(!!production_status && production_status === "embroidered") &&
                                        <button type="button" className="ml-2 btn btn-danger"
                                            onClick={this._isOpenModal}>
                                            Đánh dấu lỗi
                                        </button>
                                    }
                                    {!isPartnerGlobal &&
                                        (
                                            !!production_status && production_status === "embroidered" ?
                                                <button type="button" className="ml-2 btn btn-warning text-white"
                                                    onClick={this._isOpenMarkErrorEmbroidered}>
                                                    Lỗi thêu
                                                </button> :
                                                <button type="button" className="ml-2 btn btn-warning text-white"
                                                    onClick={this._isOpenSewingRepairModal}>
                                                    Sửa may
                                                </button>
                                        )}
                                </div>

                                <div className="d-flex align-items-center justify-content-end col-7 px-0">

                                    {typeQC &&
                                    <div className='d-flex align-items-center'>
                                        <input className="mr-2" checked={allSelected} readOnly id="checkAll"
                                               type="checkbox"
                                               onClick={toggleSelectAll}/>
                                        <label htmlFor="checkAll">Chọn tất cả</label>
                                    </div>
                                    }
                                    {
                                        !!itemSets.length &&
                                        <div className="set-items d-flex flex-wrap">
                                            {
                                                itemSets.map(set => (
                                                    <div className="set-item" style={{whiteSpace: 'nowrap'}} key={set._id}>
                                                        <Checkbox checked={set.checked} onChange={e => onChangeItemSet(e.target.checked, set._id)}>
                                                            <span style={{ fontSize: '20px', fontWeight: 600 }}>{set.name}</span>
                                                        </Checkbox>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    }
                                    {isPartnerQM && !!is3d.tags && is3d.tags.includes('priority-store') && !skuNotQC1ST.includes(product_type) &&
                                    ((loadingQC1ST || selectedItem.length === 0) ?
                                        <Button
                                            type="primary"
                                            disabled={false}
                                            className="ml-3 CustomPopConfirm">
                                            {
                                                loadingQC1ST ? textLoading : 'Đánh dấu QC lần 1'
                                            }
                                        </Button> :
                                        <Popconfirm placement="top" className='CustomPopConfirm'
                                                    icon={<Icon type="question-circle"/>}
                                                    title={`Bạn chắc chắn muốn Đánh dấu QC lần 1 cho sản phẩm này?`}
                                                    onConfirm={submitQC1ST} okText={'Đánh dấu QC lần 1'}
                                                    cancelText="Hủy" disabled={disabledBtnQC1ST}>
                                            <Button type="primary" size='large' disabled={disabledBtnQC1ST}
                                                    className="ml-3">
                                                {
                                                    loadingQC1ST ? textLoading : 'Đánh dấu QC lần 1'
                                                }
                                            </Button>
                                        </Popconfirm>)
                                    }
                                    {
                                        (loading || selectedItem.length === 0) ?
                                            <Button
                                                type="button"
                                                disabled={disabledBtnQC}
                                                className="ml-3 CustomPopConfirm">
                                                {
                                                    loading ? textLoading : name
                                                }
                                            </Button> :
                                            <Popconfirm placement="top" className='CustomPopConfirm'
                                                        icon={<Icon type="question-circle"/>}
                                                        title={`Bạn chắc chắn muốn ${name} cho sản phẩm này?`}
                                                        onConfirm={() => {
                                                            if (!!designRootMismatchWarning) {
                                                                const modal = Modal.confirm({
                                                                    title: 'Cảnh báo',
                                                                    content: designRootMismatchWarning,
                                                                    okText: 'Xác nhận',
                                                                    cancelText: 'Hủy',
                                                                    onOk: async () => {
                                                                        await submitQC()
                                                                        modal.destroy()
                                                                    },
                                                                })
                                                            } else {
                                                                submitQC()
                                                            }
                                                        }} okText={name}
                                                        cancelText="Hủy" disabled={disabledBtnQC}>
                                                <Button
                                                    type="button"
                                                    disabled={disabledBtnQC}
                                                    className="ml-3">
                                                    {
                                                        loading ? textLoading : name
                                                    }
                                                </Button>
                                            </Popconfirm>
                                    }
                                </div>
                            </div>
                            {!brand_name && !!listDes &&
                            <div className="foot d-flex align-items-center justify-content-between w-100">
                                {!brand_name && (listDes.length > 1 ?
                                        <div style={{background: 'rgb(233 236 239)', color: 'black'}}
                                             className='w-100 border'>
                                            <ul className='mt-3 pr-3' style={{fontWeight: '400', fontSize: '1rem'}}>
                                                {listDes.length && listDes.map(i => (<li>{i}</li>))}
                                            </ul>
                                        </div> :
                                        (!!listDes &&
                                            <div style={{background: 'rgb(233 236 239)', color: 'black'}}
                                                 className='w-100 border'>
                                                <ul className='mt-3 px-4' style={{fontWeight: '400', fontSize: '1rem'}}>
                                                    {listDes}
                                                </ul>
                                            </div>
                                        )
                                )}
                            </div>
                            }
                            <div className="ImageBrand mt-3">
                                {
                                    !!branding && branding.map(item => (
                                        <div className="BrandItem" key={item._id}>
                                            <div>
                                                {
                                                    [
                                                        <span className='font-weight-bold'>{item.name}</span>,
                                                        item.description && <span>: {item.description}</span>
                                                    ].filter(Boolean)
                                                }
                                            </div>
                                            <div className="mb-2">Qty = {item.quantity_per_item || 1}</div>
                                            <div className={item.design ? '' : 'no-design'}>
                                                {!!item.design && <img src={item.design || ''}
                                                                       alt="preview"/>
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>

                            {
                                !!Object.keys(brandDescription).length && 
                                <div className="brand-description mb-2">
                                    <div className="description">
                                        <pre>{brandDescription.description}</pre>
                                    </div>
                                    <div className="images">
                                        {
                                            brandDescription.images.map(i => (
                                                <div className="image-item">
                                                    <img src={i} alt="preview" />
                                                    <EyeTwoTone
                                                        className='eyes-image-item'
                                                        onClick={() => {
                                                            this.setState({
                                                                previewOpen: true,
                                                                previewColorImage: i,
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            }

                            {embroiderySides.length > 0 &&
                                <OrderMockUp mockUpFront={mock_up_front} mockUpBack={mock_up_back} orderId={item._id} />
                            }
                            <Modal
                                visible={previewOpen}
                                title={'Preview image'}
                                footer={null}
                                onCancel={() => this.setState({previewOpen: false})}
                            >
                                <img
                                    alt="preview"
                                    style={{ width: '100%' }}
                                    src={previewColorImage}
                                />
                            </Modal>
                        </div>
                        <div className="col-sm-7">
                            <div className="ImagePreview position-relative" style={{overflow : hasSpecialTag ? 'visible' : 'hidden'}}>
                                {/* <div className="d-flex Fastproduction w-100" style={{ top: -56 }}>
                                    {
                                        isFastProductionTag &&
                                        <span className='mr-3'>Sản xuất nhanh</span>
                                    }
                                    {
                                        isCutoffTag &&
                                        <span className='mr-3'>Cutoff</span>
                                    }
                                </div> */}
                                <img style={{height: `${height - 210}px`}} src={['GIFTCARD_1800NO'].includes(product_type) ? is3d.mock_up_front : is3d.preview_image || is3d.designFront}
                                    className='previewImage NotOpacity'
                                    alt='preview'/>
                                {
                                    !offSafeZone && showSafeZone(type, size)
                                }
                                {
                                    !!is3d.safezone_image &&
                                    <div className='SafeZoneAction position-absolute'>
                                        <ToggleSafeZone
                                            offSafeZone={offSafeZone}
                                            onToggleSafeZone={this._toggleSafeZone}
                                        />
                                    </div>
                                }
                                <div
                                    className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                    <span className='Icon cursor-pointer mr-2' onClick={this._showModal}><Icon
                                        type='eye'/></span>
                                </div>
                                <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                    onCancel={this._hideModal} className='PrintedFileModal'>
                                    <div className="Previewer">
                                        <img src={['GIFTCARD_1800NO'].includes(product_type) ? is3d.mock_up_front : is3d.preview_image} alt='preview' className='d-block m-auto'/>
                                        {
                                            !offSafeZone && showSafeZone2(type, size)
                                        }
                                    </div>
                                </Modal>
                                <div className="infoImage">
                                    {(isChecked || isDefaultChecked) && (
                                        <div className="checked position-absolute text-primary">
                                            <i className="fa fa-check-circle fa-2x"/>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ListItems">
                    {
                        outItems.length > 0 && <ListItemsQCnotMask outItems={outItems}/>
                    }
                </div>

                <MarkItemError
                    isOpen={isOpen}
                    id={!!is3d && !!is3d.batch_item ? is3d.batch_item._id : ''}
                    inputValue={inputValue}
                    reset={reset}
                    onClose={this._isCloseModal}
                    is3d={is3d}
                    isPartnerGlobal={isPartnerGlobal}
                />
                <SewingRepairModal
                    isOpen={showSewingRepair}
                    itemId={!!is3d && !!is3d.batch_item ? is3d.batch_item._id : ''}
                    inputValue={inputValue}
                    onClose={this._isCloseSewingRepairModal}
                    reset={reset}
                    title="Đánh dấu item cần sửa may"
                    titleBtn="Đánh dấu sửa may"
                    options={ERROR_SEWING}
                    api={markSewingRepair}
                />
                <SewingRepairModal
                    isOpen={isModalMarkErrorEmbroidered}
                    itemId={!!is3d && !!is3d.batch_item ? is3d.batch_item._id : ''}
                    inputValue={inputValue}
                    onClose={this._isCloseMarkErrorEmbroidered}
                    reset={reset}
                    title="Đánh dấu item lỗi thêu"
                    titleBtn="Đánh dấu lỗi thêu"
                    options={ERROR_EMBROIDERED}
                    api={markErrorEmbroidered}
                />
            </div>
        )
    }
}

ItemQCnotMask.propTypes = {
    item: PropTypes.object.isRequired,
    arrChecked: PropTypes.array,
    updateOrdersSelected: PropTypes.func.isRequired,
}

export default ItemQCnotMask
